import Swal from "sweetalert2"
import faradayApi from "../../api/faradayApi"


export const addCompany = async (formValues, succesMsg, errorMsg, dupCifMsg, navigate, url) => {

    try {
        const {data} = await faradayApi.post('/companies', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            navigate(url)
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        if (error?.response?.data?.msg?.original?.code === 'ER_DUP_ENTRY'){
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: dupCifMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: error,
                icon: "error",
                iconColor: '#FF7765'
            })
        }
        return false
    }
}

export const deleteCompany = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm ) => {
    const {value} = await Swal.fire({
        text: `${deleteConfirm} ${e.row.name}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
      })
    value && onConfirm(e.row.id, succesMsg, errorMsg, e.row.name)
}

const onConfirm = async (id, succesMsg, errorMsg, name) => {
    const { data } = await faradayApi.delete('/companies', { data: { id } });

        data.data !== 0 && !data.error  ?
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${name} ${succesMsg}`,
                icon: "success",
            })
            :
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
            })       
}


export const editCompany = async (formValues, succesMsg, errorMsg) => {

    try {
        const { data } = await faradayApi.put('/companies', formValues)

        if (data.status === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${formValues.name} ${succesMsg}`,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)

        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false

    }
}